module.exports = __webpack_public_path__ + "img/ballast-5-20.6e16fe11.png";